import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, getName } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './WS.css'

function WelcomeScreen() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let playerName = useSelector(getName);
    return (
        <div className='WS_imageAnimate'>
            <div className='WS_div'>

                <div>
                    {language === 'english' ?
                        <p className='WS_welcomeMessageEnglish'> Dear <span className='WS_name'> {playerName}</span> ! Welcome to Saira’s home</p>
                        :
                        // <p className='WS_welcomeMessageUrdu'>  <span style={{marginRight: '1.1vw'}}>آپ کو سائرہ کے گھر میں خوش آمدید <span className='WS_name'>{` ${playerName} `} </span> !<span style={{marginLeft: '0.9vw'}}> محترم </span></span>  </p>
                        // <div className='WS_welcomeMessageUrdu'>       <p style={{ backgroundColor: 'green'}}>آپ کو سائرہ کے گھر میں خوش آمدید <span className='WS_name'>{` Zaeem `}!</span> محترم </p></div>
                        <div className='WS_welcomeMessageUrdu'>       <p >آپ کو سائرہ کے گھر میں خوش آمدید  </p><p className='WS_name'>{` ${playerName}`}!  <span style={{color: 'white'}}>محترم</span></p></div>
                    }
                </div>

                <div>
                    {language === 'english' ?
                        <p className='WS_paragraphEnglish'>To help her, you have to carefully read the questions and answer them. Make sure you correct them after you have given a wrong answer. All your right answers will get Saira out of trouble</p>
                        :
                        <p className='WS_paragraphUrdu'>اس کی مدد کرنے کے لیے ، آپ کو دھیان سے سوالات کو پڑھنا ہوگا اور ان کے جوابات دینا ہوں گے۔ غلط جواب دینے کے بعد اس بات کو یقینی بنائیں کہ آپ انہیں درست کریں۔ آپ کے تمام درست جوابات سائرہ کو پریشانی سے دور کردیں گے</p>
                    }
                </div>

                <div>
                    {language === 'english' ?
                        <p className='WS_paragraphReadyEnglish'>Are you ready !</p>
                        :
                        <p className='WS_paragraphReadyUrdu'>کیا آپ تیار ہیں</p>
                    }
                </div>

                <div className='WS_buttonDiv'>
                    <button onClick={() => { dispatch(pageUp()) }} className='WS_button'>
                        {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                    </button>
                </div>
            </div>
        </div>


    )
}

export default WelcomeScreen;